import { axiosPrivate } from "./axios";

export const bannerByApi = async (payloadData) => {
  let res = await axiosPrivate.get("/frontend/sliders", payloadData);
  return res.data;
};
